import { Component, ReactNode } from "react";

/**
 * Blindagem das superfícies de comunicados. Como barra/sino vivem no Header
 * (global), um erro aqui não pode derrubar a app: o boundary engole e renderiza
 * nada. O comunicado some, o resto do sistema segue.
 */
export class ComunicadosBoundary extends Component<{ children: ReactNode }, { erro: boolean }> {
  state = { erro: false };

  static getDerivedStateFromError() {
    return { erro: true };
  }

  render() {
    if (this.state.erro) return null;
    return this.props.children;
  }
}
